import React from "react";
import { useTranslation } from "react-i18next";
import { AiChatPanel } from "@/components/ai/AiChatPanel";

export const AiGeneratorTab: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col h-full p-4 md:p-6">
      <div className="w-full max-w-[1440px] mx-auto flex flex-col h-full gap-4">
        <div className="shrink-0">
          <h1 className="text-3xl font-bold">
            {t("aiAgent.generator.tabTitle")}
          </h1>
          <p className="text-muted-foreground mt-2">
            {t("aiAgent.generator.tabDescription")}
          </p>
        </div>

        <div className="flex-1 min-h-0">
          <AiChatPanel />
        </div>
      </div>
    </div>
  );
};
